import Vue from 'vue'
import App from './App.vue'
import components from './components'

//Set global constants
Vue.prototype.$Home = 'Home';
Vue.prototype.$Intro = 'intro';
Vue.prototype.$GuidanceForm = 'guidanceForm';
Vue.prototype.$FormSummary = 'formSummary';
Vue.prototype.$Share = 'share';
Vue.prototype.$PrivacyStatement = 'privacyStatement';

Vue.config.productionTip = false

new Vue({
  components,
  render: h => h(App),
}).$mount('#app')
